const defaultImages = Array.from({ length: 15 }, (_, i) => `/home/nt${i + 1}.webp`);

const MasterTools = ({ images = defaultImages }) => {
  const tools = images.map((image, i) => ({ image, alt: `Tool ${i + 1}` }));

  return (
    <div
      data-section-theme="light"
      className="w-full bg-white font-fira-sans relative"
      style={{
        borderTop: "1px solid #08090A33",
        borderBottom: "1px solid #08090A33",
      }}
    >
      {/* Blur background image - absolute positioned at bottom of MAIN div */}
      <img
        src="/home/toolsblur.svg"
        alt=""
        className="absolute bottom-0 left-0 w-full h-[300px] pointer-events-none z-50" 

      />

      {/* Container with left and right borders */}
      <div
        className="gutter-x relative"
        style={{
          borderLeft: "1px solid #08090A33",
          borderRight: "1px solid #08090A33",
        }}
      >
        {/* Content with 60px left padding */}
        <div className="px-4 md:px-0 md:pl-[60px] md:pr-[60px] py-16 relative z-10">
          {/* Heading Section */}
          <div className="mb-12">
            <p className="text-black text-[16px] tracking-[1.75px] leading-[160%] font-normal uppercase mb-4">
              HANDS-ON WITH REAL TOOL
            </p>
            <h2 className="text-black text-[38px] leading-[120%] font-medium">
              Master Tools of the Trade
            </h2>
          </div>

          {/* Tools Grid - 3 rows × 5 columns */}
          <div className="space-y-8">
            {/* Row 1 */}
            <div className="flex flex-wrap md:flex-nowrap gap-8">
              {tools.slice(0, 5).map((tool, index) => (
                <div
                  key={index}
                  className="tool-card  overflow-hidden cursor-pointer"
                >
                  <img
                    src={tool.image}
                    alt={tool.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Row 2 */}
            <div className="flex flex-wrap md:flex-nowrap gap-8">
              {tools.slice(5, 10).map((tool, index) => (
                <div
                  key={index}
                  className="tool-card overflow-hidden cursor-pointer"
                >
                  <img
                    src={tool.image}
                    alt={tool.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Row 3 */}
            <div className="flex flex-wrap md:flex-nowrap gap-8">
              {tools.slice(10, 15).map((tool, index) => (
                <div
                  key={index}
                  className="tool-card overflow-hidden cursor-pointer"
                >
                  <img
                    src={tool.image}
                    alt={tool.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Row 4 - Empty Cards with Black Borders */}
            <div className="flex flex-wrap md:flex-nowrap gap-8 h-[100px]">
              {Array.from({ length: 5 }, (_, index) => (
                <div
                  key={index}
                  className="tool-card bg-white border border-black flex-1"
                >
                  {/* Empty card - matches tool card dimensions */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterTools;
